import type { ParsedLocation } from "@tanstack/react-router";

/** タブ切り替えでスクロール位置を持ち越したい画面（ボトムナビのおすすめ・さがす） */
const TAB_PATHS = ["/recommend", "/discover"];

/**
 * スクロール位置の保存キー。
 * 既定は履歴エントリごとのキーで、タブを切り替えるたびに新規遷移として先頭から始まってしまう。
 * おすすめ・さがすはパス単位のキーにして、タブを行き来しても各画面が自分の位置に戻るようにする。
 */
export const getScrollRestorationKey = (location: ParsedLocation): string => {
  const path = location.pathname.replace(/\/$/, "");
  // location.pathname は basepath を除いた内部パスなので、完全一致で判定する
  if (TAB_PATHS.includes(path)) return path;
  // TanStack Router の既定と同じ
  return location.state.__TSR_key || location.href;
};
